import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, DetailsSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemMobile: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const middleInfos1 = [
    { label: 'Empresa', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: 'Nome', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos2 = [
    { label: 'Cód. Isin', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: 'Alteração', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos3 = [
    { label: 'Negociação', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: 'Liquidação', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos4 = [
    { label: 'Limitador', value: <TextSkeleton w="60%" />, w: '49%' },
    {
      label: '',
      value: (
        <Stack w="1/2">
          <ButtonSkeleton />
        </Stack>
      ),
      w: '49%',
    },
  ];

  const infos = [middleInfos1, middleInfos2, middleInfos3, middleInfos4];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack alignItems="center" space={Spacing['inline.quarck']}>
          <DetailsSkeleton />
          <TextSkeleton w="35%" />
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space={Spacing['stack.quarck']} key={label}>
                {!!label && (
                  <UI.Text color="neutral.black" variant="semibold">
                    {label}
                  </UI.Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
